import { combineReducers } from 'redux';

import hotelDetailReducer from './hotelDetailReducer';
import searchReducer from './searchReducer';
import userReducer from './userReducer';
import voucherReducer from './voucherReducer';
import pageConfigurationReducer from './pageConfigurationReducer';
import hotelDetailTransactionReducer from './hotelDetailTransaction';
import flightsSearchOneWay from './flightsSearchOneWay';
import flightsSearchBody from './flightsSearchBody';
import flightsSearchMultipleDestination from './flightsSearchMultipleDestination';
import isThreeDaysSearchReducer from './isThreeDaysSearchReducer';
import flightsSearchRoundTrip from './flightsSearchRoundTrip';
import flightSearchType from './flightSearchType';
import searchFlightsResult from './searchFlightsResult';
import isNewSearch from './isNewSearch';
import searchLinkReducer from './searchLinkReducer';

import fFranquicia from './fFranquicia';
import searchAssistReducer from './searchAssistReducer';
import quoteSelected from './quoteSelected';
import formNoViaja from './formNoViaja';
import formPassengers from './formPassengers';
import formContact from './formContact';
import assistEmitedData from './assistEmitedData';
import searchFlightsResultPersonalized from './searchPersonalizedSearch';
import personalizedIndex from './personalizedIndex';
import tabTouch from './tabTouch';
import hotelFormikValues from './hotelFormikValues';
import integrationsRedurcer from './integrationsRedurcer';
import providersReducer from './providersReducer';
import providersPriorityReducer from './providersPriority';
import sharedSearchReducer from './sharedSearchReducer';

import flightsSearch from './flightsSearch';

const allReducers = combineReducers({
  search: searchReducer,
  hotelDetail: hotelDetailReducer,
  voucherInfo: voucherReducer,
  userInfo: userReducer,
  pageConfiguration: pageConfigurationReducer,
  hotelDetailTransactionReducer: hotelDetailTransactionReducer,
  flightsSearchOneWay: flightsSearchOneWay,
  flightsSearchBody: flightsSearchBody,
  isThreeDaysSearch: isThreeDaysSearchReducer,
  flightsSearchRoundTrip: flightsSearchRoundTrip,
  flightsSearchMultipleDestination: flightsSearchMultipleDestination,
  flightSearchType: flightSearchType,
  searchFlightsResult: searchFlightsResult,
  isNewSearch: isNewSearch,
  searchLink: searchLinkReducer,
  fFranquicia: fFranquicia,
  searchAssistReducer: searchAssistReducer,
  quoteSelected: quoteSelected,
  formNoViaja: formNoViaja,
  formPassengers: formPassengers,
  formContact: formContact,
  assistEmitedData: assistEmitedData,
  searchFlightsResultPersonalized: searchFlightsResultPersonalized,
  personalizedIndex: personalizedIndex,
  tabTouch: tabTouch,
  hotelFormikValues: hotelFormikValues,
  integrations: integrationsRedurcer,
  providers: providersReducer,
  providersPriorityReducer: providersPriorityReducer,
  sharedSearch: sharedSearchReducer,
  flightsSearch: flightsSearch,
});

export default allReducers;
